import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Flame } from "lucide-react";

const AdminProtected = ({ children }) => {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (location.state?.user) return children;
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-[#F6F0E6]">
        <div className="icon-badge !h-12 !w-12 mb-4">
          <Flame className="h-6 w-6 text-[#F28C18] animate-pulse" strokeWidth={1.5} />
        </div>
        <div className="overline">Verifying access</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminProtected;
